import { FC } from "react";

import { IErrorComponent } from "../ErrorComponent";
import { ErrorTemplate } from "../blocks/ErrorTemplate";
import { ServerUnavailableIcon } from "../../../icons/errors";

export const ServerUnavailableError: FC<IErrorComponent> = (props) => {
  const message = "Мы уже знаем об этой проблем и работаем над её исправлением";
  const additionalMessage = "Пожалуйста, попробуйте повторить действие позже";

  return (
    <ErrorTemplate
      {...props}
      icon={ServerUnavailableIcon}
      message={message}
      additionalMessage={additionalMessage}
      showReloadButton={false}
    />
  );
};
